import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    dashboardMaintenanceContainer: {
      width: '87%',
      background: 'transparent',
      padding: '32px 32px 40px 40px',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        padding: '10px 7px 40px 7px'
      },
      [theme.breakpoints.only('lg')]: {
        padding: '10px 7px 15px 7px'
      }
    },
    hardwareTableMaintenance: {
      height: '600px',
      maxHeight: '640px',
      flex: 'none',
      background: 'transparent',
      width: '100%',
      [theme.breakpoints.down('lg')]: {
        height: '530px'
      }
    },
    dashboardMaintenanceKioskInfo: {
      height: '600px',
      background: 'transparent',
      width: '100%',
      minHeight: '520px',
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        height: '570px'
      }
    },
    dashboardKioskActions: {
      background: 'transparent',
      margin: '0px 0px 24px 0px',
      minWidth: '100%',
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        height: '330px',
        padding: '0px 20px 0px 15px'
      }
    },
    dashboardReloadAppBlock: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%'
    },
    dashboardReloadAppButton: {
      width: '450px',
      [theme.breakpoints.down('lg')]: {
        width: '340px',
        height: '56px'
      }
    },
    dashboardTableInfoContainer: {
      justifyContent: 'space-between',
      paddingRight: '32px',
      [theme.breakpoints.down('lg')]: {
        paddingRight: '0px'
      }
    },
    hardwareTableBox: {
      flex: 1,
      background: 'transparent'
    }
  })
);
